import { withPrefix } from 'gatsby-link'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import Layout from '../../components/layout'

const Ldap = () => {
  return (
    <Layout>
      <div className="row">
        <div className="col">
          <h3 className="instruction__heading instruction__heading_h3">Инструкция по переходу на единую авторизацию МАИ</h3>
          <p>Переход на единую авторизацию МАИ позволит Вам использовать имя пользователя и пароль от единой учётной записи МАИ для авторизации в СЭО <a rel="noreferrer" href="https://lms.mai.ru/" target="_blank">lms.mai.ru</a>.</p>
          <p>Авторизуйтесь в СЭО МАИ введя свои логин и пароль на странице авторизации, расположенной по адресу <a rel="noreferrer" href="https://lms.mai.ru/" target="_blank">lms.mai.ru</a> (рис. 1).</p>
          <a rel="noreferrer" className="item__img" target="_blank" href={withPrefix('/images/videoincourse/image1.png')}><StaticImage src="../../../static/images/videoincourse/image1.png" alt="Рис. 1" /></a>
          <p className="item__img-number"><em>Рис. 1</em></p>
          <p>Перейдите в свой личный кабинет (рис. 2).</p>
          <a rel="noreferrer" className="item__img" target="_blank" href={withPrefix('/images/ldap/image1.png')}><StaticImage src="../../../static/images/ldap/image1.png" alt="Рис. 2" /></a>
          <p className="item__img-number"><em>Рис. 2</em></p>
          <p>Нажмите на кнопку «Перейти на единую авторизацию МАИ» (Рис. 3).</p>
          <a rel="noreferrer" className="item__img" target="_blank" href={withPrefix('/images/ldap/image2.png')}><StaticImage src="../../../static/images/ldap/image2.png" alt="Рис. 3" /></a>
          <p className="item__img-number"><em>Рис. 3</em></p>
          <p>В появившемся окне нажмите на кнопку «Да» (Рис. 4).</p>
          <a rel="noreferrer" className="item__img" target="_blank" href={withPrefix('/images/ldap/image3.png')}><StaticImage src="../../../static/images/ldap/image3.png" alt="Рис. 4" /></a>
          <p className="item__img-number"><em>Рис. 4</em></p>
          <p>Готово. Теперь Вам необходимо выйти из аккаунта, после чего Вы сможете зайти, используя данные единой учетной записи МАИ.</p>
        </div>
      </div>
    </Layout>
  )
}

export default Ldap
   